/* ========== TNID Load More – "Rodyti daugiau prekių" (saugi versija) ========== */
/*
 * Pataisymai:
 *  - UI dedamas PO grido konteinerio (ne į vidų), kad temos rūšiavimo/filtrų AJAX jo neliestų
 *  - viskas try/catch – jei kažkas lūžta, puslapis nesugadinamas
 *  - atsistato iš naujo kai tema perkrauna gridą (rūšiavimas/filtrai)
 */
(function () {
  "use strict";

  var WRAP_ID = "FilterProductGrid";
  var UI_ID = "tnid-lm";
  var busy = false;
  var pagesLoaded = 1;

  function wrap() { return document.getElementById(WRAP_ID); }
  function grid() { var w = wrap(); return w ? w.querySelector("ul.product-grid") : null; }

  if (!wrap()) return;

  function injectCss() {
    if (document.getElementById("tnid-lm-css")) return;
    var css =
      "#" + WRAP_ID + " .pagination{display:none !important;}" +
      "#" + UI_ID + "{max-width:520px;margin:40px auto 10px;text-align:center;padding:0 16px;}" +
      "#" + UI_ID + " .tnid-lm-count{font-size:15px;color:#444;margin-bottom:14px;}" +
      "#" + UI_ID + " .tnid-lm-bar{height:6px;background:#e6e2da;border-radius:999px;overflow:hidden;margin:0 auto 22px;max-width:320px;}" +
      "#" + UI_ID + " .tnid-lm-bar span{display:block;height:100%;background:#3b331f;width:0;transition:width .3s ease;}" +
      "#" + UI_ID + " .tnid-lm-btn{display:inline-block;min-width:260px;padding:15px 28px;border:0;cursor:pointer;background:#efece7;color:#2a2a2a;font-size:15px;font-weight:600;transition:background .15s;}" +
      "#" + UI_ID + " .tnid-lm-btn:hover{background:#e4e0d8;}" +
      "#" + UI_ID + " .tnid-lm-btn[disabled]{opacity:.6;cursor:default;}";
    var s = document.createElement("style");
    s.id = "tnid-lm-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function countProducts(g) {
    try { return g.querySelectorAll(":scope > li:not(.tnid-promo-li)").length; }
    catch (e) { return g ? g.children.length : 0; }
  }

  function readTotal() {
    try {
      var el = document.getElementById("FilterProductCount");
      if (el) {
        var m = (el.textContent || "").replace(/\s/g, "").match(/\d+/);
        if (m) return parseInt(m[0], 10);
      }
    } catch (e) {}
    var g = grid();
    return g ? countProducts(g) : 0;
  }

  function buildUrl(page) {
    var u = new URL(window.location.href);
    u.searchParams.set("page", String(page));
    return u.pathname + u.search;
  }

  function ui() { return document.getElementById(UI_ID); }

  function updateProgress(shown, total) {
    var u = ui(); if (!u) return;
    var count = u.querySelector(".tnid-lm-count");
    var bar = u.querySelector(".tnid-lm-bar span");
    if (count) count.textContent = "Peržiūrėta " + shown + " iš " + total + " prekių";
    if (bar) bar.style.width = (total ? Math.min(100, Math.round((shown / total) * 100)) : 0) + "%";
  }

  function hideButton() {
    var u = ui(); if (!u) return;
    var btn = u.querySelector(".tnid-lm-btn");
    if (btn) btn.style.display = "none";
  }

  function setLoading(on) {
    var u = ui(); if (!u) return;
    var btn = u.querySelector(".tnid-lm-btn");
    if (!btn) return;
    btn.disabled = !!on;
    btn.textContent = on ? "Kraunama…" : "Rodyti daugiau prekių";
  }

  function ensureUI() {
    try {
      var w = wrap();
      var g = grid();
      if (!w || !g) return;

      var u = ui();
      if (!u) {
        pagesLoaded = 1;
        injectCss();
        u = document.createElement("div");
        u.id = UI_ID;
        u.innerHTML =
          '<div class="tnid-lm-count"></div>' +
          '<div class="tnid-lm-bar"><span></span></div>' +
          '<button type="button" class="tnid-lm-btn">Rodyti daugiau prekių</button>';
        // SVARBU: dedam PO grido konteinerio, ne į jo vidų
        if (w.parentNode) w.parentNode.insertBefore(u, w.nextSibling);
        else w.appendChild(u);
        var b = u.querySelector(".tnid-lm-btn");
        if (b) b.addEventListener("click", loadMore);
      }

      var total = readTotal();
      var shown = countProducts(g);
      updateProgress(shown, total);
      var btn = u.querySelector(".tnid-lm-btn");
      if (btn) btn.style.display = (shown >= total) ? "none" : "inline-block";
    } catch (e) { /* tyliai */ }
  }

  function loadMore() {
    if (busy) return;
    var g = grid();
    if (!g) return;
    busy = true;
    setLoading(true);

    fetch(buildUrl(pagesLoaded + 1), { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        if (!html) throw new Error("no html");
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newGrid = doc.querySelector("#" + WRAP_ID + " ul.product-grid");
        var items = newGrid ? Array.prototype.slice.call(newGrid.children) : [];
        if (!items.length) { hideButton(); return; }
        var gg = grid(); if (!gg) return;
        items.forEach(function (li) { gg.appendChild(document.importNode(li, true)); });
        pagesLoaded++;
        var total = readTotal();
        var shown = countProducts(gg);
        updateProgress(shown, total);
        if (shown >= total) hideButton();
      })
      .catch(function () {})
      .then(function () { busy = false; setLoading(false); });
  }

  /* ---------- stebim grido perkrovimą, bet SAUGIAI ---------- */
  var t = null, lastGrid = null;
  function schedule() {
    if (t) return;
    t = setTimeout(function () {
      t = null;
      var g = grid();
      // jei gridas pasikeitė (temos rūšiavimas/filtrai) – resetinam UI
      if (g && g !== lastGrid) {
        lastGrid = g;
        pagesLoaded = 1;
        var old = ui();
        if (old && old.parentNode) old.parentNode.removeChild(old);
      }
      ensureUI();
    }, 250);
  }

  function watch() {
    if (!("MutationObserver" in window)) return;
    try {
      var section = document.querySelector("loess-product-filters") || document.body;
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && n.id !== UI_ID &&
                n.querySelector && (n.matches && n.matches("ul.product-grid") || n.querySelector("ul.product-grid"))) {
              schedule();
              return;
            }
          }
        }
      });
      mo.observe(section, { childList: true, subtree: true });
    } catch (e) {}
  }

  function init() {
    lastGrid = grid();
    ensureUI();
    watch();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();